require('./bootstrap');
require("bootstrap-datepicker");

$(document).ready(function(){

  var data_bon = $('#data_bon');
    var container_data_bon = $('.bootstrap-iso form').length > 0 ? $('.bootstrap-iso form').parent() : "body";
    var optiuni_data_bon = {
        format: 'yyyy-mm-dd',
        container: container_data_bon,
        todayHighlight: true,
        autoclose: true,
        orientation: "bottom",
        language: "ro"
    };
    data_bon.datepicker(optiuni_data_bon);

  $(".navbar a").on('click', function(event) {

    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;

      $('html, body').animate({
        scrollTop: $(hash).offset().top - 60
      }, 900, function(){
        // window.location.hash = hash;
      });
    } 

  });

  $('div.navbar-nav a.nav-item').on('click', function(){
      $("#navbarNavAltMarkup").removeClass("show");
  });
    
  $('.navbar-toggler').on('click', function() {
    $('.navbar').toggleClass('bkgIconMob');
  });
  
});

$(document).scroll(function () {
	var $nav = $(".fixed-top");
	$nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
});
